// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"b18f23f8","787":"db7a54f8","900":"52c71a65"}[chunkId] + ".chunk.js";
};